import ForgetPasswordPage from 'pages/auth/forgetPasswordPage';
import LoginPage from 'pages/loginPage';
import ResetPasswordPage from 'pages/auth/resetPasswordPage';
import OnboardingPage from "pages/auth/onboardingPage";
import CallbackPage from 'pages/auth/callbackPage';
import PublicRoute from 'components/PublicRoute';

const publicRoutes = [
    {
        path: "/",
        name: "Login | Register",
        element: <PublicRoute><LoginPage /></PublicRoute>,
    },
    {
        path: "/forgot-password",
        name: "Forgot Password",
        element: <PublicRoute><ForgetPasswordPage /></PublicRoute>,
    },
    // {
    //     path: "/reset-password",
    //     name: "Reset Password",
    //     element: <ResetPasswordPage />,
    // },
    {
        path: "/onboard",
        name: "Onboarding",
        element: <PublicRoute><OnboardingPage /></PublicRoute>,
    },
    {
        path: "/auth/callback",
        name: "Google Auth Callback",
        element: <CallbackPage />,
    }
]

export default publicRoutes;